export default "/images/movesense_instruction.webp"